import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { http } from "@next-core/http";
/**
 * @description 获取实例详情
 * @endpoint GET /object/:objectId/instance/:instanceId
 */
export var InstanceApi_getDetail = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (objectId, instanceId, params, options) {
    return (/**! @contract easyops.api.cmdb.instance.GetDetail@1.0.0 */(yield http.get("api/gateway/cmdb.instance.GetDetail/object/".concat(objectId, "/instance/").concat(instanceId), _objectSpread(_objectSpread({}, options), {}, {
        params
      }))).data
    );
  });
  return function InstanceApi_getDetail(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=getDetail.js.map